<template>
  <div class="bg-black-darker bg-opacity-50 h-screen w-screen"></div>
</template>
<script>
export default {
  name: "BackgroundLayer",
};
</script>